<template>
  <div>
    <el-row class="gray-box vertical-center-box mr-b30" type="flex">
      <span>푸시 알림 수신 여부</span>
      <el-switch v-model="infoTypeReceiveFlag.GLOBAL" active-value="Y" inactive-value="N"></el-switch>
    </el-row>
    <el-row>
      <div class="list form-list">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form label-width="150px" label-position="left">
                <el-form-item label="이벤트">
                  <el-switch v-model="infoTypeReceiveFlag.EVENT" :disabled="receiveFlagDisabled" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
                <el-form-item label="사전 예측 이벤트">
                  <el-switch v-model="infoTypeReceiveFlag.PREDICT_EVENT" :disabled="receiveFlagDisabled" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
                <el-form-item label="쪽지">
                  <el-switch v-model="infoTypeReceiveFlag.MESSAGE" :disabled="receiveFlagDisabled" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
                <el-form-item label="공지사항">
                  <el-switch v-model="infoTypeReceiveFlag.NOTICE" :disabled="receiveFlagDisabled" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
                <el-form-item label="구성 정보 변경">
                  <el-switch v-model="infoTypeReceiveFlag.CHANGE_CONFIG" :disabled="receiveFlagDisabled" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form label-width="150px" label-position="left">
                <el-form-item label="정기 점검">
                  <el-switch v-model="infoTypeReceiveFlag.REGULAR_CHECK" :disabled="receiveFlagDisabled" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
                <el-form-item label="예정 작업">
                  <el-switch v-model="infoTypeReceiveFlag.PLANNDED_WORK" :disabled="receiveFlagDisabled" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
                <el-form-item label="작업 상태 변경">
                  <el-switch v-model="infoTypeReceiveFlag.CHANGE_WORK" :disabled="receiveFlagDisabled" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
                <el-form-item label="토폴로지맵 변경">
                  <el-switch v-model="infoTypeReceiveFlag.CHANGE_TOPOLOGYMAP" :disabled="receiveFlagDisabled" active-value="Y" inactive-value="N"></el-switch>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
      </div>
    </el-row>
  </div>
</template>

<script>
import { keys, cloneDeep, isEmpty } from 'lodash';
import msgUtil from '@/utils/message';
import pushNotificationApi from '@/api/frame/push-notification';

export default {
  name: 'WPushNotificationSettingView',
  props: {
    activeSubTab: {
      type: String,
    },
  },
  data() {
    return {
      infoTypeReceiveFlag: {
        GLOBAL: 'Y',
        EVENT: 'Y',
        PREDICT_EVENT: 'Y',
        MESSAGE: 'Y',
        NOTICE: 'Y',
        CHANGE_CONFIG: 'Y',
        REGULAR_CHECK: 'Y',
        PLANNDED_WORK: 'Y',
        CHANGE_WORK: 'Y',
        CHANGE_TOPOLOGYMAP: 'Y',
      },
      originalReceiveFlag: null,
    };
  },
  computed: {
    receiveFlagDisabled() {
      return this.infoTypeReceiveFlag.GLOBAL === 'N';
    },
  },
  watch: {
    activeSubTab(activeSubTab) {
      if (activeSubTab === 'pushNotification') {
        this.loadData();
      }
    },
  },
  methods: {
    /**
     * 로그인한 계정 기준 푸시 알림 수신여부 설정 조회
     * @author jeee12
     * @return {[type]} [description]
     */
    loadData() {
      pushNotificationApi.getPushNotificationReceiveFlagSettingData().then((response) => {
        if (response.data.success) {
          const receiveFlagData = response.data.data;
          this.infoTypeReceiveFlag = cloneDeep(receiveFlagData);
          this.originalReceiveFlag = cloneDeep(receiveFlagData);
        }
      });
    },
    /**
     * 로그인한 계정 기준 푸시 알림 수신여부 설정 수정
     * @author jeee12
     */
    setPushNotificationReceiveData() {
      const modifiedReceiveFlag = keys(this.infoTypeReceiveFlag).reduce((acc, infoTypeId) => {
        if (this.infoTypeReceiveFlag[infoTypeId] !== this.originalReceiveFlag[infoTypeId]) {
          acc[infoTypeId] = this.infoTypeReceiveFlag[infoTypeId];
        }
        return acc;
      }, {});

      if (!isEmpty(modifiedReceiveFlag)) {
        const target = '푸시 알림 수신 여부 설정';
        const action = msgUtil.action.MODIFY;
        pushNotificationApi.updatePushNotificationReceiveFlagSetting(modifiedReceiveFlag).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/PushNotificationSettingView.vue